"use strict";
Shopify.theme.jsFeaturedCollection = {
    init: function (e) {
        (Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData(e))),
            this.enable_masonry_layout && !this.align_height && "grid" == this.collection_style && Shopify.theme.applyMasonry(),
            "slider" == this.collection_style && this.createSlider();
    },
    createSlider: function () {
        var e = $(".featured-collection.layout--slider .slider-gallery"),
            t = this.products_per,
            i = (this.products_available, this.products_limit),
            l = !0;
        $(e).flickity({
            lazyLoad: 2,
            freeScroll: !0,
            imagesLoaded: !0,
            draggable: !0,
            cellAlign: "center",
            wrapAround: l,
            pageDots: !1,
            contain: !0,
            prevNextButtons: t < i,
            initialIndex: 0,
            arrowShape: arrowShape,
            on: {
                ready: function () {
                    setTimeout(function () {
                        $(e).flickity("resize");
                    }, 500);
                },
            },
        });
    },
    unload: function (e) {
        e.find(".flickity-enabled").flickity("destroy");
    },
};
